import { action } from 'satcheljs/lib/legacy';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getCalendarPath, getOwaUrlWithAddedQueryParameters } from 'owa-url';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const showCalendar = action('showCalendar')(function showCalendar(
    newWindow: Window
): Promise<void> {
    const userOptions = getUserConfiguration().UserOptions;

    // switch to calendar module
    const calendarUrl =
        isFeatureEnabled('cal-react') ||
        (userOptions &&
            userOptions.ReactOptinSettings &&
            userOptions.ReactOptinSettings.CalendarEnabled)
            ? getHostLocation()
                  .href.replace(getHostLocation().hash, '')
                  .replace(getHostLocation().pathname, getCalendarPath())
            : getOwaUrlWithAddedQueryParameters({ path: '/calendar' });

    newWindow.open(calendarUrl, '_self');
    return Promise.resolve();
});

export default showCalendar;
